export default __webpack_public_path__ + "static/media/firas.8a90f426.jpg";